import { render, staticRenderFns } from "./CarrouselCourse.vue?vue&type=template&id=665f89b8&scoped=true"
import script from "./CarrouselCourse.vue?vue&type=script&lang=js"
export * from "./CarrouselCourse.vue?vue&type=script&lang=js"
import style0 from "./CarrouselCourse.vue?vue&type=style&index=0&id=665f89b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f89b8",
  null
  
)

export default component.exports